export default __webpack_public_path__ + "static/tag-dont-1-dark-743382935879c382ab768536942635bb.png";